import { render, staticRenderFns } from "./ProductView.template.vue?vue&type=template&id=62625020&scoped=true&"
var script = {}
import style0 from "./ProductView.template.vue?vue&type=style&index=0&id=62625020&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62625020",
  null
  
)

export default component.exports